import StateHelper from "./StateHelper";
import { PageState } from "./types";
import { AxiosRequestConfig } from "axios";

// function setCookie(cname : string, cvalue : string, exdays : number) {
//   const d = new Date();
//   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//   let expires = "expires="+d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

function getCookie(cname : string) : string{
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
      c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
  }
  return "";
}

export function getHeadersConfig(includeViewAsUser: boolean = true): AxiosRequestConfig {
  const config:AxiosRequestConfig = {}
  config.headers = {}

  const pageState : PageState = StateHelper.getPageState();
  
  if (pageState.viewAs !== null && includeViewAsUser === true) {
    config.headers[process.env.REACT_APP_ASSUME_USER_HEADER_NAME] = pageState.viewAs;
  }

  // only need to do "withCredentials" if we can't get the session token
  // out of the cookie - and normally we need to rely on getting the session
  // token due to changes in how Chrome handles XHR requests to another domain
  // with cookies that aren't both "secure" and "SameSite='None'"
  config.withCredentials = true;
  var jwt = getCookie('apt.session_jwt');
  if ( jwt ) {
    config.withCredentials = false;
    config.headers['Authorization'] = 'Bearer ' + jwt;
  }

  // don't include both the cookie and the Authorization token
  if ( !jwt && process.env.REACT_APP_USE_DEVELOPMENT_AUTH_TOKEN === "true" ) {
    config.headers[process.env.REACT_APP_TOKEN_HEADER_NAME] = process.env.REACT_APP_TOKEN;
  }

  return config;
}
